import Modal from '../../../components/Modal'
import { CircularProgress } from '@mui/material'
import AuthError from '../../../components/ErrorComponents/AuthError'
import LanguageStrings from '../../../i18n/locales'

const FirmwareUpgradeStatusStrings =
  LanguageStrings().FirmwareUpgradeStatusStrings

interface FirmwareActionProps {
  firmwareCampaignStopStatus: any
  setShowStopStatus: (show: boolean) => void
  callGetFirmwareCampaignListApi: () => void
}

export const HandleStopCampaignWithFailure = ({
  firmwareCampaignStopStatus,
  setShowStopStatus,
  callGetFirmwareCampaignListApi
}: FirmwareActionProps): JSX.Element => {
  // istanbul ignore else
  if (
    firmwareCampaignStopStatus.httpStatus === 200 &&
    firmwareCampaignStopStatus.campaignStopData === true
  ) {
    return (
        <Modal
            buttonTypeNegative="hollow"
            title={FirmwareUpgradeStatusStrings.Success}
            LabelPositive="Ok"
            onClickPositive={() => {
              setShowStopStatus(false)
              callGetFirmwareCampaignListApi()
            }}
            onClose={() => {
              setShowStopStatus(false)
              callGetFirmwareCampaignListApi()
            }}
        >
            <p style={{ paddingTop: '1.2em' }}>
              {FirmwareUpgradeStatusStrings.stopedSuccessfully}
            </p>
        </Modal>
    )
  } else if (firmwareCampaignStopStatus.isLoading === true) {
    return (
        <Modal title={FirmwareUpgradeStatusStrings.Loading}>
            <div className="CircularprogressAmi">
                <CircularProgress />
            </div>
        </Modal>
    )
  } else if (firmwareCampaignStopStatus.httpStatus === 400) {
    return (
        <Modal
            buttonTypeNegative="hollow"
            title={FirmwareUpgradeStatusStrings.Failed}
            LabelPositive={FirmwareUpgradeStatusStrings.Ok}
            onClickPositive={() => {
              setShowStopStatus(false)
            }}
            onClose={() => {
              setShowStopStatus(false)
            }}
        >
            <p style={{ paddingTop: '1.2em' }}>
                {firmwareCampaignStopStatus.error}
            </p>
        </Modal>
    )
  } else if (firmwareCampaignStopStatus.httpStatus === 401) {
    return (
        <div className="authError">
            <AuthError errorMessage="Unauthorized" />
        </div>
    )
  } else if (firmwareCampaignStopStatus.httpStatus === 403) {
    return (
        <div className="authError">
            <AuthError errorMessage="accessForbidden" />
        </div>
    )
  } else {
    return (
        <Modal
            buttonTypeNegative="hollow"
            title={FirmwareUpgradeStatusStrings.Failed}
            LabelPositive={FirmwareUpgradeStatusStrings.Ok}
            onClickPositive={() => {
              setShowStopStatus(false)
            }}
            onClose={() => {
              setShowStopStatus(false)
            }}
        >
            <p style={{ paddingTop: '1.2em' }}>
                {firmwareCampaignStopStatus.error}
            </p>
        </Modal>
    )
  }
}
